var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"sign-in",style:({
    alignItems: 'normal',
    minHeight: '100vh',
    position: 'relative'
  }),attrs:{"region":"main"}},[_c('div',{staticClass:"Gradient-bg",style:({
      position: 'absolute',
      height: '100%',
      width: '100%',
      overflow: 'hidden'
    })},[_c('Cloud1',{style:({
        position: 'absolute',
        right: '-34%',
        bottom: '-25%',
        width: '90%',
        height: '120%',
        opacity: '.7'
      })}),_c('Cloud2',{style:({
        position: 'absolute',
        right: '-34%',
        bottom: '-25%',
        width: '90%',
        height: '120%',
        opacity: '.7'
      })})],1),_c('div',{style:(Object.assign({}, {position: 'absolute'},

      (_vm.breakpoint === 'desktop'
        ? {
            width: '60%',
            minWidth: '500px'
          }
        : {
            width: '100%',
            minWidth: 'initial'
          }),

      {height: '100%',
      borderTopRightRadius: '16px',
      borderBottomRightRadius: '16px',
      backgroundColor: '#fff',

      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'}))}),_c('div',{style:(Object.assign({}, {position: 'relative',

      paddingTop: '100px'},

      (_vm.breakpoint === 'desktop'
        ? {
            width: '60%',
            minWidth: '500px'
          }
        : {
            width: '100%',
            minWidth: 'initial'
          }),

      {borderRadius: '16px',

      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'}))},[_c('div',{style:({
        width: '80%',
        marginBottom: '50px'
      })},[_c('Logo',{style:({
          position: 'relative'
        })})],1),_c('span',{staticClass:"Welcome-Lets-Get-Y",style:({
        position: 'relative',
        width: '80%',
        marginBottom: '50px'
      })},[(_vm.scope === 'homeowner')?_c('p',{staticClass:"text-style-1"},[_vm._v("Welcome to the Homeowner Portal")]):_vm._e(),(_vm.scope === 'management')?_c('p',{staticClass:"text-style-1"},[_vm._v("Welcome to the Board Portal")]):_vm._e(),(_vm.scope === 'vendor')?_c('p',{staticClass:"text-style-1"},[_vm._v("Welcome to the Vendor Portal")]):_vm._e(),(_vm.scope === 'onboarding')?_c('p',{staticClass:"text-style-1"},[_vm._v("Welcome to the Onboarding Portal")]):_vm._e(),_c('p',[_vm._v("Let’s Get You Started!")])]),(_vm.authReady && !_vm.authUser)?_c('div',{staticClass:"form-box",style:({
        margin: 0,
        padding: 0,
        width: '80%',
        maxWidth: 'initial'
      })},[_c('section',{attrs:{"id":"sign-in-form"},on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit.apply(null, arguments)}}},[_c('b-field',{style:({ position: 'relative', color: '#777777' }),attrs:{"label":"Username"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],style:(_vm.styles.input),attrs:{"placeholder":_vm.$t('auth.email'),"type":"email","icon":"email","tests-id":"email"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_c('b-field',{style:({ position: 'relative', color: '#777777' }),attrs:{"label":"Password"}},[((_vm.passShowing ? 'text' : 'password')==='checkbox')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],style:(_vm.styles.input),attrs:{"password-input":"","tests-id":"password","placeholder":_vm.$t('auth.password'),"icon":"lock","autocomplete":"current-password","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.password)?_vm._i(_vm.password,null)>-1:(_vm.password)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onSubmit.apply(null, arguments)},"change":function($event){var $$a=_vm.password,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.password=$$a.concat([$$v]))}else{$$i>-1&&(_vm.password=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.password=$$c}}}}):((_vm.passShowing ? 'text' : 'password')==='radio')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],style:(_vm.styles.input),attrs:{"password-input":"","tests-id":"password","placeholder":_vm.$t('auth.password'),"icon":"lock","autocomplete":"current-password","type":"radio"},domProps:{"checked":_vm._q(_vm.password,null)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onSubmit.apply(null, arguments)},"change":function($event){_vm.password=null}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],style:(_vm.styles.input),attrs:{"password-input":"","tests-id":"password","placeholder":_vm.$t('auth.password'),"icon":"lock","autocomplete":"current-password","type":_vm.passShowing ? 'text' : 'password'},domProps:{"value":(_vm.password)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onSubmit.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_c('button',{style:({
              position: 'absolute',
              width: '45px',
              height: '45px',
              right: 0,
              bottom: 0
            }),attrs:{"pass-toggle":"","aria-hidden":"true"},on:{"click":_vm.togglePass}},[_c('Transition',{attrs:{"name":"fade"}},[(!_vm.passShowing)?_c('Eye',{style:(_vm.styles.eyeButtons)}):_vm._e()],1),_c('Transition',{attrs:{"name":"fade"}},[(_vm.passShowing)?_c('EyeFull',{style:(_vm.styles.eyeButtons)}):_vm._e()],1)],1)]),_c('div',{staticClass:"field"},[_c('transition',{attrs:{"name":"fade","appear":""}},[(_vm.authError)?_c('div',{staticClass:"alert alert-warning",style:({
                color: _vm.theme.color[4]
              }),attrs:{"role":"alert"}},[_vm._v(" "+_vm._s(_vm.authError)+" ")]):_vm._e()])],1),_c('div',{style:({
            display: 'flex',
            justifyContent: 'space-between',
            padding: '8px 0'
          })},[_c('b-field',{style:({ margin: 0 })},[_c('b-checkbox',{model:{value:(_vm.rememberUsername),callback:function ($$v) {_vm.rememberUsername=$$v},expression:"rememberUsername"}},[_vm._v("Remember my username")])],1),_c('div',[(['homeowner', 'vendor'].includes(_vm.scope))?_c('router-link',{staticClass:"href-overflow-wrap is-primary is-medium router-link-a",attrs:{"to":{
                name: _vm.signUpLink
              }}},[_vm._v("New User Registration")]):_vm._e()],1)],1),_c('div',{style:({
            display: 'flex',
            justifyContent: 'end',
            padding: '8px 0 16px'
          })},[_c('router-link',{staticClass:"href-overflow-wrap is-primary is-medium router-link-a",attrs:{"to":{
              name: 'forgotpassword'
            }}},[_vm._v("Forgot Password")])],1),_c('button',{staticClass:"button is-primary is-pulled-right",style:({
            width: '100%',
            borderRadius: '5px',
            boxShadow: '0 40px 40px 0 rgba(184, 184, 184, 0.3)',
            backgroundImage: 'linear-gradient(to right, #2cabe1, #398ce5)'
          }),attrs:{"disabled":_vm.authLoading,"tests-id":"sign-in-button"},on:{"click":_vm.signIn}},[_vm._v(" SIGN IN NOW ")])],1)]):_vm._e(),_c('div',{style:(Object.assign({}, {display: 'flex',
        margin: '30px 0',
        width: '80%',
        justifyContent: 'space-between'},

        (_vm.breakpoint === 'desktop'
          ? {}
          : {
              flexDirection: 'column'
            })))},[_c('b-tooltip',{style:(Object.assign({}, _vm.styles.appButtons, {
            boxShadow: 'initial'
          })),attrs:{"label":"Not yet implemented"}},[_c('button',{style:(Object.assign({}, _vm.styles.appButtons, {
              width: '100%',
              opacity: '.3'
            })),attrs:{"aria-label":"download iOS app","disabled":""}},[_c('span',[_vm._v("Download App")]),_c('Apple',{style:({ marginLeft: '8px' })})],1)]),_c('div',{style:({
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',

          height: '50px'
        })},[_c('span',[_vm._v("Or")])]),_c('b-tooltip',{style:(Object.assign({}, _vm.styles.appButtons, {
            boxShadow: 'initial'
          })),attrs:{"label":"Not yet implemented"}},[_c('button',{style:(Object.assign({}, _vm.styles.appButtons, {
              width: '100%',
              opacity: '.3'
            })),attrs:{"aria-label":"download Android app","disabled":""}},[_c('span',{style:({ paddingLeft: '8px' })},[_vm._v("Download App")]),_c('Android',{style:({ marginLeft: '8px' })})],1)])],1),_c('div',{style:({ marginBottom: '20px', marginTop: '20px' })},[_c('div',{style:({
          background: 'linear-gradient(to bottom, #123075, #092056)',
          borderRadius: '11px'
        }),attrs:{"role":"img","aria-label":"Equal Housing Opportunity Icon","tabindex":"0"}},[_c('img',{style:({
            height: _vm.breakpoint === 'mobile' ? '60px' : '120px',
            display: 'none'
          }),attrs:{"src":require("@/assets/images/CCRM-Fair-Housing-wht-150x150.png"),"alt":"Equal Housing Opportunity Icon"}})])]),_c('Modal',{attrs:{"toggle":_vm.toggle},on:{"update:toggle":function($event){_vm.toggle=$event}}},[_c('TwoFactorSigninModal',{attrs:{"requiresTwoFactor":_vm.requiresTwoFactor}})],1)],1),_c('div',{style:(Object.assign({}, {position: 'absolute',
      right: 0,
      bottom: 0},

      (_vm.scope === 'homeowner'
        ? {
            height: '60%',
            width: '60%'
          }
        : {
            height: '56%',
            width: '56%'
          }),

      {overflow: 'hidden',

      pointerEvents: 'none'}))},[_c('Transition',{attrs:{"name":"fade"}},[(_vm.breakpoint === 'desktop' && _vm.scope === 'homeowner')?_c('House',{style:({
          position: 'relative',

          right: '-50px',
          bottom: '-30px',

          height: '100%',
          width: '100%'
        })}):_vm._e(),(_vm.breakpoint === 'desktop' && _vm.scope === 'management')?_c('Meeting',{style:({
          position: 'relative',

          right: '-50px',
          bottom: '-30px',

          height: '100%',
          width: '100%'
        })}):_vm._e()],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }